import {useContext} from "react";
import {SourceTrackingContext} from "./SourceTrackingProvider/SourceTrackingProvider";

export const useSourceTracking = () => {
    const context = useContext(SourceTrackingContext);

    if (!context) {
        throw new Error("useSourceTracking must be used within a SourceTrackingProvider");
    }

    return {
        updateSourceTrackingParamLocally: context.updateSourceTrackingParamLocally,
        saveSourceTrackingParams: context.saveSourceTrackingParams,
        redirectWithSourceTracking: context.redirectWithSourceTracking,
        getSourceTrackingParams: context.getSourceTrackingParams,
    };
};
